export default __webpack_public_path__ + "static/media/Icon-Flexible-Hours.87e8d3ef.svg";